export default function TestimonialSection() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Fashion Buyer, New York',
      avatar: 'S',
      rating: 5,
      text: 'OOPBuy Spreadsheet completely changed how I manage bulk fashion orders. The organized layout and real-time tracking features saved me hours every week. I can now process three times as many orders with zero mistakes.',
    },
    {
      name: 'David Chen',
      role: 'E-commerce Reseller, London',
      avatar: 'D',
      rating: 5,
      text: 'I was skeptical at first, but after switching to OOPBuy Spreadsheet, my order error rate dropped to nearly zero. The price comparison feature alone has saved me thousands in just a few months of use.',
    },
    {
      name: 'Emma Rodriguez',
      role: 'Personal Shopper, Los Angeles',
      avatar: 'E',
      rating: 5,
      text: 'As a personal shopper handling dozens of clients, the spreadsheet system is a lifesaver. I can manage multiple orders across 14 categories without ever losing track. Highly recommend for anyone serious about efficient shopping.',
    },
    {
      name: 'James Turner',
      role: 'Wholesale Buyer, Chicago',
      avatar: 'J',
      rating: 4,
      text: 'Great tool for wholesale purchasing. The bulk order features and category filters make it easy to navigate large inventories. Only wish the mobile version had a few more features, but desktop experience is flawless.',
    },
    {
      name: 'Olivia Park',
      role: 'Online Retailer, Sydney',
      avatar: 'O',
      rating: 5,
      text: 'OOPBuy Spreadsheet is hands down the best investment I have made for my online store. The ability to compare suppliers and track orders in one dashboard has streamlined my entire supply chain.',
    },
    {
      name: 'Michael Brown',
      role: 'Dropshipping Expert, Toronto',
      avatar: 'M',
      rating: 5,
      text: 'After trying multiple shopping management tools, OOPBuy Spreadsheet stands out for its simplicity and power. The learning curve is minimal and the efficiency gains are immediate.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-accent-400"></div>
            <p className="text-xs md:text-sm text-foreground-500 tracking-wider whitespace-nowrap">User Reviews</p>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Trusted by Smart Shoppers
            <br />
            Around the World
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            See what real users are saying about their experience with OOPBuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-yellow-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">{t.name}</h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">{t.text}</p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center text-background-50 text-xs font-bold flex-shrink-0">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800 whitespace-nowrap">{t.name}</p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}